import {
  validatePaidSubscription
} from "../appContainer";

export default {
  bind(el, binding, vnode) {
    updateElement(el, binding, vnode);
  },
  update(el, binding, vnode) {
    updateElement(el, binding, vnode);
  },
};

function updateElement(el, binding, vnode) {
    if (!binding.value || !binding.value.companyId) {
      el.style.opacity = '';
      el.style.pointerEvents = '';
      el.removeAttribute('title');
      return;
    }

    const { companyId } = binding.value;

    const companiesOfUser = vnode.context.$store.state.user.companies;
    const company = companiesOfUser[companyId];

    const hasSubscription = validatePaidSubscription.isValid(company);

    if (!hasSubscription) {
      el.style.opacity = '0.5';
      el.style.pointerEvents = 'none';
      el.setAttribute('title', vnode.context.$t('subscription.requiresSubscription'));
      return;
    }

    el.style.opacity = '';
    el.style.pointerEvents = '';
    el.removeAttribute('title');
}
